import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const MAX_UNDO_STACK_SIZE = 100;

export type UndoableAction = {
    description: string;
    undoCallback: () => void;
    redoCallback: () => void;
};

export type State = {
    undoStack: UndoableAction[];
    redoStack: UndoableAction[];
};
const initialState: State = {
    undoStack: [],
    redoStack: [],
};

export const undoRedoSlice = createSlice({
    name: "undoRedo",
    initialState,
    reducers: {
        push: (state, action: PayloadAction<UndoableAction>) => {
            const { payload: undoableAction } = action;
            state.undoStack.push(undoableAction);
            if (state.undoStack.length > MAX_UNDO_STACK_SIZE) {
                state.undoStack.shift();
            }
            state.redoStack = [];
        },
        undo: (state) => {
            const undoableAction = state.undoStack.pop();

            if (!undoableAction) {
                return;
            }

            state.redoStack.push(undoableAction);
        },
        redo: (state) => {
            const undoableAction = state.redoStack.pop();
            if (!undoableAction) {
                return;
            }

            state.undoStack.push(undoableAction);
        },
        clear: (state) => {
            state.undoStack = [];
            state.redoStack = [];
        },
    },
});

const { actions, reducer } = undoRedoSlice;
export { actions as undoRedoActions, reducer as undoRedoReducer };
